import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Action, Dispatch } from "redux"
import services from '../../services'
import Loader from '../../components/Loader'
import { autoSignIn } from '../../store/actions/auth'
import { UserInDto } from '../../types/user.dto'

interface AuthContextType {
  isAuthenticated: boolean
  user: UserInDto | null
}

interface AuthProviderType {
  children: React.ReactNode
  signinStates: {
    loading: boolean
    success: boolean
    error: string | boolean
  }
  signoutStates: {
    loading: boolean
    success: boolean
    error: string | boolean
  }
  currentUser: UserInDto
  currentUserState: {
    loading: boolean
    success: boolean
    error: string | boolean
  }
}

export let AuthContext = React.createContext<AuthContextType>(null!)

const AuthProvider = ({ children, currentUser, currentUserState, signinStates, signoutStates }: AuthProviderType) => {
  const [checkingAuth, setCheckingAuth] = useState<boolean>(true)
  const [autoSignInTriggered, setAutoSignInTriggered] = useState<boolean>(false)
  const dispatch = useDispatch<Dispatch<Action>>()

  useEffect(() => {
    if (!signinStates.loading && !autoSignInTriggered) {
      setAutoSignInTriggered(true)
      dispatch(autoSignIn())
    }
  }, [signinStates.loading, autoSignInTriggered, dispatch])

  useEffect(() => {
    // Si hay un usuario, ya no estamos verificando autenticación
    if (currentUser) {
      setCheckingAuth(false)
      return
    }

    // Si no hay usuario y no estamos cargando, y ya se disparó autoSignIn
    if (!currentUser && !currentUserState.loading && autoSignInTriggered) {
      setCheckingAuth(false)
    }
  }, [currentUser, currentUserState.loading, autoSignInTriggered])

  return (
    <AuthContext.Provider value={{ user: currentUser, isAuthenticated: !!currentUser }}>
      {checkingAuth ? <Loader /> : children}
    </AuthContext.Provider>
  )
}

const states = ({ userStore, authStore }) => {
  const { data: currentUser, states: currentUserState } = userStore.currentUser
  const { states: signinStates } = authStore.signin
  const { states: signoutStates } = authStore.signout

  return {
    currentUser,
    currentUserState,
    signinStates,
    signoutStates,
  }
}

export default connect(states)(AuthProvider)
